<div class="summary-modal-wrapper" *ngIf="summaryData">

  <!-- ===== HEADER ===== -->
  <div class="summary-header">
    <div class="header-left">
      <div class="header-icon">🏥</div>
      <div>
        <h6 style="color: white;">AI Diagnostic Overview</h6>
        <p>Intelligent patient care overview</p>
      </div>
    </div>
    <div class="d-flex align-items-center gap-2" style="gap:10px;">
      <div class="urgent-badge" *ngIf="isUrgentReferral">
        ⚠️ URGENT REFERRAL
      </div>
      <button class="close-btn" (click)="close()">✕</button>
    </div>
  </div>

  <!-- ===== BODY ===== -->
  <div class="summary-body" #summaryBody (scroll)="onBodyScroll()">


    <!-- PRESCRIBED MEDICATIONS -->
    <div class="section-card medications-card" *ngIf="summaryData?.prescribed_medications_prediction">
      <div class="section-title">
        💊 PRESCRIBED MEDICATIONS
      </div>
      <div style="overflow-x: auto;">
        <table class="med-table">
          <thead>
            <tr>
              <th>MEDICINE</th>
              <th>TYPE</th>
              <th>DOSE &amp; STRENGTH</th>
              <th>FREQUENCY</th>
              <th>DURATION</th>
              <th>INDICATION &amp; INSTRUCTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let med of summaryData.prescribed_medications_prediction">
              <!-- Medicine -->
              <td>
                <div style="display:flex; align-items:center; gap:6px;">
                  <div class="med-icon">
                    <span *ngIf="med.drug_type === 'TABLETS'">💊</span>
                    <span *ngIf="med.drug_type === 'SYRUPS'">🍶</span>
                    <span *ngIf="med.drug_type !== 'TABLETS' && med.drug_type !== 'SYRUPS'">💉</span>
                  </div>
                  <div>
                    <div class="med-name">{{ med.name }}</div>
                    <div class="med-strength">{{ med.strength }}</div>
                  </div>
                </div>
              </td>
              <!-- Type -->
              <td>
                <div class="med-type">{{ med.drug_type }}</div>
              </td>
              <!-- Dose & Strength -->
              <td>
                <div style="font-weight:600;">{{ med.dose }}</div>
                <div class="med-strength">{{ med.strength }}</div>
              </td>
              <!-- Frequency -->
              <td>
                <div class="freq-slot" *ngIf="isMorning(med)">
                  <span class="slot-label">☀️ Morning</span>
                  <span class="tick">✓</span>
                </div>
                <div class="freq-slot" *ngIf="isAfternoon(med)">
                  <span class="slot-label">🌤 Afternoon</span>
                  <span class="tick">✓</span>
                </div>
                <div class="freq-slot" *ngIf="isEvening(med)">
                  <span class="slot-label">🌙 Evening</span>
                  <span class="tick">✓</span>
                </div>
                <div class="freq-slot" *ngIf="isNight(med)">
                  <span class="slot-label">🌑 Night</span>
                  <span class="tick">✓</span>
                </div>
              </td>
              <!-- Duration -->
              <td>
                <div class="duration-chip">
                  📅 {{ med.count }} {{ med.period }}
                </div>
              </td>
              <!-- Indication & Instructions -->
              <td style="min-width:170px;">
                <div class="med-indication">
                  <span class="med-label">Indication:</span> {{ med.indication }}
                </div>
                <div class="med-instruction mt-1">
                  <span class="med-label">Instruction:</span> {{ med.instruction }}
                </div>
                <div class="med-safety mt-1">
                  <span class="med-label">Safety:</span> {{ med.safety_notes }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    
    <!-- Row 1: Red Flags + Diagnosis -->
    <div class="row no-gutters" style="gap:0;">
      <div class="col-md-5 pr-md-1"  *ngIf="summaryData?.red_flags && summaryData?.red_flags.length > 0">
        <!-- RED FLAGS -->
        <div class="section-card red-flags-card h-100">
          <div class="section-title">
            <span style="color:#e74c3c;">⚠️</span> RED FLAGS
          </div>
          <div *ngFor="let flag of summaryData.red_flags" class="red-flag-item">
            <div class="red-flag-icon-wrap">
              <span>{{ getRedFlagIcon(flag.finding) }}</span>
            </div>
            <div class="red-flag-content">
              <div class="finding-name">{{ flag.finding }}</div>
              <div class="finding-value">{{ flag.value }}</div>
              <div class="finding-significance">{{ flag.clinical_significance }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7 pl-md-1 mt-2 mt-md-0" *ngIf="summaryData?.clinical_assessment">

  <!-- DIAGNOSIS -->
  <div class="section-card diagnosis-card h-100">

    <div class="section-title">
      📋 DIAGNOSIS
    </div>

    <!-- Most Likely Condition -->
    <div style="color:#888; font-size:11px;">
      Most Likely Condition:
    </div>

    <div class="condition-name">
      {{ summaryData.clinical_assessment?.most_likely_condition?.diagnosis_name }}
    </div>

    <!-- ICD Code -->
    <div
      *ngIf="summaryData.clinical_assessment?.most_likely_condition?.icd_10_code"
      style="font-size:12px; color:#777;">

      ICD-10:
      {{ summaryData.clinical_assessment?.most_likely_condition?.icd_10_code }}

    </div>

    <span class="confidence-badge">
      CONFIDENCE:
      {{ summaryData.clinical_assessment?.confidence }}
    </span>


    <div class="findings-grid">

      <!-- Supporting Findings -->
      <div class="findings-col">

        <h6>Supporting Findings</h6>

        <ul>
          <li
            *ngFor="let sf of summaryData.clinical_assessment?.supporting_findings">

            {{ sf }}

          </li>
        </ul>

      </div>


      <!-- Differential Diagnoses -->
      <div class="findings-col">

        <h6>Differential Diagnoses</h6>

        <ul>

          <li
            *ngFor="let dd of summaryData.clinical_assessment?.differential_diagnoses">

            {{ dd?.diagnosis_name }}

            <span
              *ngIf="dd?.icd_10_code"
              style="font-size:11px; color:#888;">

              ({{ dd.icd_10_code }})

            </span>

          </li>

        </ul>

      </div>

    </div>


    <!-- Clinical Reasoning -->
    <div class="reasoning-box mt-2">

      <strong>Clinical Reasoning Summary</strong><br>

      {{ summaryData?.clinical_reasoning_summary }}

    </div>

  </div>

</div>
    </div>

    <!-- RECOMMENDED INVESTIGATIONS -->
    <div class="section-card investigations-card" *ngIf=" summaryData?.recommended_investigations && summaryData?.recommended_investigations.length > 0">
      <div class="section-title">
        🔬 RECOMMENDED INVESTIGATIONS
      </div>
      <div class="invest-chips">
        <div class="invest-chip" *ngFor="let inv of summaryData.recommended_investigations; let i = index">
          <!-- <div class="invest-icon">
            <span *ngIf="i === 0">🩻</span>
            <span *ngIf="i === 1">🩸</span>
            <span *ngIf="i >= 2">🧪</span>
          </div> -->
          {{ inv?.investigation }}
        </div>
      </div>
    </div>

    <!-- Bottom 3-col: Referral | Advice | Follow-up -->
    <div class="bottom-grid" *ngIf="summaryData?.referral_recommendation">

      <!-- REFERRAL -->
      <div class="section-card referral-card">
        <div class="section-title">
          👤 REFERRAL RECOMMENDATION
        </div>
        <div class="ref-row">
          <strong>Required:</strong>
          <span class="tag-yes" *ngIf="summaryData.referral_recommendation?.required">YES</span>
          <span class="tag-no" *ngIf="!summaryData.referral_recommendation?.required">NO</span>
        </div>
        <div class="ref-row">
          <strong>Urgency:</strong>
          <span class="tag-urgency">{{ summaryData.referral_recommendation?.urgency }}</span>
        </div>
        <div class="ref-reason">{{ summaryData.referral_recommendation?.reason }}</div>
      </div>

      <!-- ADVICE -->
      <div class="section-card advice-card">
        <div class="section-title">
          💬 ADVICE
        </div>
        <div class="advice-item" *ngIf="summaryData.advice_prediction?.restExercise">
          <span class="advice-icon">🛌</span>
          <div>
            <div class="advice-label">Rest &amp; Exercise:</div>
            <div class="advice-text">{{ summaryData.advice_prediction.restExercise }}</div>
          </div>
        </div>
        <div class="advice-item" *ngIf="summaryData.advice_prediction?.diet">
          <span class="advice-icon">🥗</span>
          <div>
            <div class="advice-label">Diet:</div>
            <div class="advice-text">{{ summaryData.advice_prediction.diet }}</div>
          </div>
        </div>
        <div class="advice-item" *ngIf="summaryData.advice_prediction?.followAdvice">
          <span class="advice-icon">👨‍⚕️</span>
          <div>
            <div class="advice-label">Follow Advice:</div>
            <div class="advice-text">{{ summaryData.advice_prediction.followAdvice }}</div>
          </div>
        </div>
      </div>

      <!-- FOLLOW-UP -->
      <div class="section-card followup-card">
        <div class="section-title">
          📅 FOLLOW-UP
        </div>
        <div class="advice-item" *ngIf="summaryData.advice_prediction?.followup">
          <span class="advice-icon">🔄</span>
          <div>
            <div class="advice-label">Follow-up:</div>
            <div class="advice-text">{{ summaryData.advice_prediction.followup }}</div>
          </div>
        </div>
        <div class="advice-item" *ngIf="summaryData.advice_prediction?.doctorComment">
          <span class="advice-icon">💡</span>
          <div>
            <div class="advice-label">Doctor's Comment:</div>
            <div class="advice-text">{{ summaryData.advice_prediction.doctorComment }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- ===== FOOTER ===== -->

  <!-- ===== SCROLL INDICATOR ===== -->
  <div class="scroll-indicator" [class.visible]="hasMoreBelow" (click)="scrollDown()" title="More content below">
    <div class="scroll-indicator-inner">
      <span class="chevron">❯</span>
      <span class="chevron">❯</span>
    </div>
  </div>

</div>

<!-- No data fallback -->
<div *ngIf="!summaryData" class="p-4 text-center text-muted">
  <p>No summary data available.</p>
  <button class="btn btn-secondary btn-sm" (click)="close()">Close</button>
</div>
